module.exports = __webpack_public_path__ + "img/index_play_red.1585d391.svg";